<div class="controls-action">
  <button pButton pRipple type="button"
    *ngIf="showDownloadButton" (click)="donwload()"
    id="btn-download-data" icon="pi pi-download"
    class="p-button-rounded p-button-primary p-button-outlined ml-2">
  </button>
  <button pButton pRipple type="button"
    *ngIf="showSearchButton" (click)="searchFilter()"
    id="btn-reload-entities" icon="pi pi-search"
    class="p-button-rounded p-button-primary p-button-outlined ml-2">
  </button>
  <button pButton pRipple type="button"
    *ngIf="showReloadButton" (click)="reload()"
    id="btn-reload-entities" icon="pi pi-refresh"
    class="p-button-rounded p-button-primary p-button-outlined ml-2">
  </button>
  <button pButton pRipple type="button"
    *ngIf="showInfoButton" (click)="info()"
    id="btn-info" icon="pi pi-info-circle"
    class="p-button-rounded p-button-primary p-button-outlined ml-2">
  </button>
  <button pButton pRipple type="button"
    *ngIf="showLinkButton" (click)="link()"
    id="btn-info" icon="pi pi-link" matTooltip="Link de acesso externo"
    class="p-button-rounded p-button-primary p-button-outlined ml-2">
  </button>
  <button pButton pRipple type="button"
    *ngIf="showClearFilters" (click)="clearFilter()"
    id="btn-info" icon="pi pi-times-circle"
    class="p-button-rounded p-button-danger p-button-outlined ml-2">
  </button>
</div>
